export default __webpack_public_path__ + "static/media/arrow-back-24px.09b0e0b6.svg";